import { getTopWindowAccessible } from '../../../util';
// Matching the implementation of What we have in OpenUI5 to serve a hybrid deploy.
class TransientPreferenceStore {
  state = {};
  getItems() {
    return {
      ...this.state
    };
  }
  putItems(items) {
    for (const value of items) {
      if (typeof value.value === 'string') {
        this.state[value.key] = value.value;
      } else {
        delete this.state[value.key];
      }
    }
  }
  removeItems(keys) {
    for (const value of keys) {
      delete this.state[value.key];
    }
  }
}
export class TransientPreferenceService {
  constructor() {
    if (getTopWindowAccessible()) {
      if (!window.top.transientStore) {
        Object.defineProperty(window.top, 'transientStore', {
          configurable: false,
          enumerable: true,
          value: Object.seal(new TransientPreferenceStore())
        });
      }
      this.store = window.top.transientStore;
    } else {
      this.store = new TransientPreferenceStore();
    }
  }
  hasWriteAccess() {
    return Promise.resolve(true);
  }
  setSettings(...args) {
    const data = args[0];
    const items = data.map(item => ({
      key: item.id,
      value: item.value
    }));
    this.store.putItems(items);
    return Promise.resolve({
      items: [...data]
    });
  }
  getSettings() {
    const storeItems = this.store.getItems();
    const items = [];
    for (const key in storeItems) {
      items.push({
        id: key,
        value: storeItems[key]
      });
    }
    return Promise.resolve({
      items
    });
  }
  deleteSettings(...args) {
    const keys = args[0];
    this.store.removeItems(keys.map(key => ({
      key
    })));
    return Promise.resolve();
  }
}
//# sourceMappingURL=TransientPreferenceService.js.map